export default "__VITE_ASSET__r1aF06Y___"